(function () {
  var RT_NS = "rtSlider";
  if (window[RT_NS] && window[RT_NS].__initialized) return;

  var lenisLoadingPromise = null;

  function loadLenis() {
    if (typeof window.Lenis !== "undefined") return Promise.resolve();
    if (lenisLoadingPromise) return lenisLoadingPromise;

    lenisLoadingPromise = new Promise(function (resolve, reject) {
      var existing =
        document.querySelector('script[data-rt-slider-lenis="true"]') ||
        document.querySelector('script[src*="lenis"]');

      if (existing) {
        if (typeof window.Lenis !== "undefined") {
          resolve();
          return;
        }

        existing.addEventListener("load", function () {
          resolve();
        });

        existing.addEventListener("error", function (e) {
          reject(e);
        });
      } else {
        var s = document.createElement("script");
        s.src = "https://cdn.jsdelivr.net/npm/lenis@1.3.16/dist/lenis.min.js";
        s.async = true;
        s.setAttribute("data-rt-slider-lenis", "true");

        s.onload = function () {
          resolve();
        };

        s.onerror = function (e) {
          reject(e);
        };

        document.head.appendChild(s);
      }
    });

    return lenisLoadingPromise;
  }

  var LenisHub = (function () {
    var set = new Set();
    var rafId = 0;

    function loop(t) {
      set.forEach(function (l) {
        try {
          l.raf(t);
        } catch (e) {}
      });

      rafId = set.size ? requestAnimationFrame(loop) : 0;
    }

    return {
      add: function (lenis) {
        if (!lenis) return;

        set.add(lenis);

        if (!rafId) {
          rafId = requestAnimationFrame(loop);
        }
      },

      remove: function (lenis) {
        if (!lenis) return;

        set.delete(lenis);

        if (!set.size && rafId) {
          cancelAnimationFrame(rafId);
          rafId = 0;
        }
      },
    };
  })();

  function uid() {
    return "s" + Math.random().toString(36).slice(2);
  }

  function assignUID(el, attr) {
    if (!el.getAttribute(attr)) {
      el.setAttribute(attr, uid());
    }

    return el.getAttribute(attr);
  }

  function injectOnce(key, css) {
    var s = document.head.querySelector(
      '[data-rt-slider-injected="' + key + '"]',
    );

    if (!s) {
      s = document.createElement("style");
      s.setAttribute("data-rt-slider-injected", key);
      document.head.appendChild(s);
    }

    if (s.textContent !== css) {
      s.textContent = css;
    }

    return s;
  }

  function removeInjected(key) {
    var s = document.head.querySelector(
      '[data-rt-slider-injected="' + key + '"]',
    );

    if (s && s.parentNode) {
      s.parentNode.removeChild(s);
    }
  }

  function toSel(v) {
    return typeof v === "string" ? v.trim() : "";
  }

  function parseBool(v, def) {
    if (v === null || v === undefined) return def;

    var s = String(v).trim().toLowerCase();

    if (s === "") return true;

    if (s === "true" || s === "1" || s === "yes" || s === "y" || s === "on") {
      return true;
    }

    if (s === "false" || s === "0" || s === "no" || s === "n" || s === "off") {
      return false;
    }

    return def;
  }

  function parseNum(v, def) {
    if (v === null || v === undefined) return def;

    var s = String(v).trim();

    if (!s.length) return def;

    var n = Number(s);

    return Number.isFinite(n) ? n : def;
  }

  function parseStr(v, def) {
    if (v === null || v === undefined) return def;

    var s = String(v);

    return s.length ? s : def;
  }

  function clamp(i) {
    return i < 0 ? 0 : i > 1 ? 1 : i;
  }

  function round(n, d) {
    if (!Number.isFinite(n)) return 0;

    var m = Math.pow(10, d || 0);

    return Math.round(n * m) / m;
  }

  function parseEasing(name) {
    var n = String(name || "").trim();

    if (!n) return null;

    var map = {
      linear: function (t) {
        return clamp(t);
      },

      easeInQuad: function (t) {
        t = clamp(t);
        return t * t;
      },

      easeOutQuad: function (t) {
        t = clamp(t);
        return t * (2 - t);
      },

      easeInOutQuad: function (t) {
        t = clamp(t);

        return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
      },

      easeInCubic: function (t) {
        t = clamp(t);
        return t * t * t;
      },

      easeOutCubic: function (t) {
        t = clamp(t);
        return 1 - Math.pow(1 - t, 3);
      },

      easeInOutCubic: function (t) {
        t = clamp(t);

        return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
      },

      easeInOutSine: function (t) {
        t = clamp(t);
        return -(Math.cos(Math.PI * t) - 1) / 2;
      },

      easeOutExpo: function (t) {
        t = clamp(t);
        return t === 1 ? 1 : 1 - Math.pow(2, -10 * t);
      },
    };

    return map[n] || null;
  }

  function isTransparentColor(val) {
    if (!val) return true;

    var v = String(val).trim().toLowerCase();

    if (v === "transparent") return true;

    if (v.startsWith("rgba(")) {
      var parts = v
        .slice(5, -1)
        .split(",")
        .map(function (x) {
          return x.trim();
        });

      var a = parts.length === 4 ? Number(parts[3]) : 1;

      return !Number.isFinite(a) ? false : a === 0;
    }

    return false;
  }

  function findNearestOpaqueBgColor(el) {
    var n = el;

    while (n && n !== document.documentElement) {
      var cs = getComputedStyle(n);
      var bg = cs.backgroundColor;

      if (!isTransparentColor(bg)) {
        return bg;
      }

      n = n.parentElement;
    }

    var rootBg = getComputedStyle(document.body).backgroundColor;

    return isTransparentColor(rootBg) ? "rgb(255, 255, 255)" : rootBg;
  }

  function isOverflowingX(el) {
    if (!el) return false;

    try {
      return el.scrollWidth > el.clientWidth + 1;
    } catch (e) {
      return false;
    }
  }

  function findScrollableAncestor(el) {
    var n = el;

    while (n && n !== document.body) {
      var cs = getComputedStyle(n);
      var ox = cs.overflowX;

      var scrollable = ox === "auto" || ox === "scroll" || ox === "overlay";

      if (scrollable && isOverflowingX(n)) {
        return n;
      }

      n = n.parentElement;
    }

    return el;
  }

  function resolveControl(root, selector, sliderId) {
    if (!selector) return null;

    var local = root.querySelector(selector);

    if (local) return local;

    var byFor = document.querySelector(
      selector + '[data-rt-slider-for="' + sliderId + '"]',
    );

    if (byFor) return byFor;

    var all = Array.from(document.querySelectorAll(selector));

    if (all.length === 1) {
      return all[0];
    }

    var scoped = all.filter(function (el) {
      var owner = el.closest("[data-rt-slider]");

      return owner === root;
    });

    if (scoped.length === 1) {
      return scoped[0];
    }

    return null;
  }

  function isVisibleNode(el) {
    if (!el) return false;

    var cs = getComputedStyle(el);

    if (cs.display === "none" || cs.visibility === "hidden") {
      return false;
    }

    return el.getClientRects().length > 0;
  }

  function getConf(root) {
    return {
      list: toSel(root.getAttribute("data-rt-list")),

      item: toSel(root.getAttribute("data-rt-item")),

      spacer: toSel(root.getAttribute("data-rt-spacer")),

      btnPrev: toSel(root.getAttribute("data-rt-btn-prev")),

      btnNext: toSel(root.getAttribute("data-rt-btn-next")),

      scrollTrack: toSel(root.getAttribute("data-rt-scroll-track")),

      scrollBar: toSel(root.getAttribute("data-rt-scroll-bar")),

      marginRef: toSel(root.getAttribute("data-rt-margin-ref")),

      overlayStart: toSel(root.getAttribute("data-rt-overlay-start")),

      overlayEnd: toSel(root.getAttribute("data-rt-overlay-end")),
    };
  }

  function Slider(root, id) {
    this.root = root;
    this.id = id;
    this.conf = getConf(root);
    this.valid = !!(this.conf.list && this.conf.item);

    if (!this.valid) return;

    this.sliderId = assignUID(this.root, "data-rt-slider-id");

    this.list = this.root.querySelector(this.conf.list);

    if (!this.list) {
      this.valid = false;
      return;
    }

    this.list.style.overflowX = "auto";
    this.list.style.webkitOverflowScrolling = "touch";
    this.list.style.scrollbarWidth = "none";
    this.list.style.msOverflowStyle = "none";

    this.scroller = this.list;

    this.scroller.style.scrollbarWidth = "none";
    this.scroller.style.msOverflowStyle = "none";

    try {
      this.scroller.style.webkitOverflowScrolling = "touch";
    } catch (e) {}

    try {
      this.scroller.style.overscrollBehaviorX = "contain";
    } catch (e) {}

    this._basePaddingBottomPx = null;
    this._basePaddingCaptured = false;
    this._touchClampTimer = 0;

    this.btnPrev = this.conf.btnPrev
      ? resolveControl(this.root, this.conf.btnPrev, this.sliderId)
      : null;

    this.btnNext = this.conf.btnNext
      ? resolveControl(this.root, this.conf.btnNext, this.sliderId)
      : null;

    this.overlayStart = this.conf.overlayStart
      ? resolveControl(this.root, this.conf.overlayStart, this.sliderId)
      : null;

    this.overlayEnd = this.conf.overlayEnd
      ? resolveControl(this.root, this.conf.overlayEnd, this.sliderId)
      : null;

    if (this.overlayStart) {
      this.overlayStart.style.transition = "opacity 0.3s ease";

      this.overlayStart.style.willChange = "opacity";
    }

    if (this.overlayEnd) {
      this.overlayEnd.style.transition = "opacity 0.3s ease";

      this.overlayEnd.style.willChange = "opacity";
    }

    this.scrollTrack = this.conf.scrollTrack
      ? this.root.querySelector(this.conf.scrollTrack)
      : null;

    this.scrollBar = this.conf.scrollBar
      ? this.root.querySelector(this.conf.scrollBar)
      : null;

    this.firstItem = this.list.querySelector(this.conf.item + ":first-child");

    this.lastItem = this.list.querySelector(this.conf.item + ":last-child");

    this.dragging = false;
    this.maybeDrag = false;
    this.draggingBar = false;
    this.barPointerId = null;
    this.barOffsetX = 0;
    this.startX = 0;
    this.startScroll = 0;
    this.lastX = 0;
    this.lastT = 0;
    this.velocity = 0;
    this.inertiaId = 0;
    this.ticking = false;
    this.didDrag = false;
    this.didDragTs = 0;
    this.dragMovedPx = 0;
    this.cursorBindings = [];
    this.imgHandlers = [];
    this._roTicking = false;
    this.lenis = null;
    this._lenisWasStopped = false;

    this.mq = window.matchMedia("(hover: hover) and (pointer: fine)");

    this._injectedKey = null;
    this._lastGutterPx = 0;
    this._lastGapPx = 0;

    this.slideState = null;
    this._slideStateSig = "";
    this._progressSig = "";
    this._lastSlideStateActiveIndex = -1;
    this._lastSlideStateScrollLeft = 0;

    this._destroyed = false;
    this._layoutSettleTimer = 0;
    this._layoutSettleUntil = 0;
    this._layoutSettleSig = "";
    this._marginRefObserved = null;

    this._lastLenisScrollWidth = -1;
    this._lastLenisClientWidth = -1;

    var self = this;

    this.ro =
      typeof ResizeObserver !== "undefined"
        ? new ResizeObserver(function () {
            if (self._roTicking) return;

            self._roTicking = true;

            requestAnimationFrame(function () {
              self._roTicking = false;

              if (self._destroyed) {
                return;
              }

              self.rafUpdate();
              self.setupCursorMode();
              self.applyIOSScrollIndicatorMask();
              self.applyListStyles();

              self.scheduleLayoutSettle(900);
            });
          })
        : null;
  }

  Slider.prototype.devicePixelEpsilon = function () {
    var dpr = Math.max(1, window.devicePixelRatio || 1);

    return 1 / dpr;
  };

  Slider.prototype.scrollEdgeEpsilon = function () {
    return Math.max(2, this.devicePixelEpsilon() * 4);
  };

  Slider.prototype.listGap = function () {
    var cs = getComputedStyle(this.list);

    var g1 = parseFloat(cs.columnGap || "0") || 0;

    var g2 = parseFloat(cs.gap || "0") || 0;

    return Math.max(g1, g2);
  };

  Slider.prototype.pickVisibleMarginRef = function () {
    if (!this.conf.marginRef) {
      return null;
    }

    var nodes = this.root.querySelectorAll(this.conf.marginRef);

    if (nodes.length === 0) {
      nodes = document.querySelectorAll(this.conf.marginRef);
    }

    for (var i = 0; i < nodes.length; i++) {
      if (isVisibleNode(nodes[i])) {
        return nodes[i];
      }
    }

    return null;
  };

  Slider.prototype.getMarginRefLayoutSignature = function () {
    if (!this.conf.marginRef || !this.scroller || !this.list) {
      return "";
    }

    var ref = this.pickVisibleMarginRef();

    var sRect = this.scroller.getBoundingClientRect();

    var listRect = this.list.getBoundingClientRect();

    var scrollerCS = getComputedStyle(this.scroller);

    var listCS = getComputedStyle(this.list);

    var scrollerBorderL = parseFloat(scrollerCS.borderLeftWidth || "0") || 0;

    var scrollerPadL = parseFloat(scrollerCS.paddingLeft || "0") || 0;

    var listPadL = parseFloat(listCS.paddingLeft || "0") || 0;

    var gap = this.listGap();

    var values = [
      ref ? "ref" : "none",

      round(sRect.left, 3),

      round(sRect.width, 3),

      round(listRect.left, 3),

      round(listRect.width, 3),

      round(this.scroller.clientWidth || 0, 3),

      round(this.scroller.scrollWidth || 0, 3),

      round(scrollerBorderL, 3),

      round(scrollerPadL, 3),

      round(listPadL, 3),

      round(gap, 3),
    ];

    if (ref) {
      var rRect = ref.getBoundingClientRect();

      values.push(round(rRect.left, 3));

      values.push(round(rRect.width, 3));
    } else {
      values.push("none");
      values.push("none");
    }

    return values.join("|");
  };

  Slider.prototype.syncMarginRefObservation = function () {
    if (!this.ro || !this.conf.marginRef) {
      return;
    }

    var nextRef = this.pickVisibleMarginRef();

    if (nextRef === this._marginRefObserved) {
      return;
    }

    if (this._marginRefObserved) {
      try {
        this.ro.unobserve(this._marginRefObserved);
      } catch (e) {}
    }

    this._marginRefObserved = nextRef || null;

    if (this._marginRefObserved) {
      try {
        this.ro.observe(this._marginRefObserved);
      } catch (e) {}
    }
  };

  Slider.prototype.cancelLayoutSettle = function () {
    if (this._layoutSettleTimer) {
      clearTimeout(this._layoutSettleTimer);

      this._layoutSettleTimer = 0;
    }

    this._layoutSettleUntil = 0;
    this._layoutSettleSig = "";
  };

  Slider.prototype.scheduleLayoutSettle = function (duration) {
    if (!this.conf.marginRef || this._destroyed) {
      return;
    }

    var now =
      typeof performance !== "undefined" &&
      typeof performance.now === "function"
        ? performance.now()
        : Date.now();

    var ms = Number.isFinite(duration) ? Math.max(0, duration) : 1600;

    this._layoutSettleUntil = Math.max(this._layoutSettleUntil, now + ms);

    if (this._layoutSettleTimer) {
      return;
    }

    var self = this;

    var tick = function () {
      self._layoutSettleTimer = 0;

      if (self._destroyed) {
        return;
      }

      self.syncMarginRefObservation();

      var signature = self.getMarginRefLayoutSignature();

      if (signature !== self._layoutSettleSig) {
        self._layoutSettleSig = signature;

        self.rafUpdate();
        self.setupCursorMode();

        self.syncMarginRefObservation();

        self._layoutSettleSig = self.getMarginRefLayoutSignature();
      }

      var current =
        typeof performance !== "undefined" &&
        typeof performance.now === "function"
          ? performance.now()
          : Date.now();

      if (current < self._layoutSettleUntil) {
        self._layoutSettleTimer = setTimeout(tick, 50);
      } else {
        self._layoutSettleUntil = 0;
      }
    };

    tick();
  };

  Slider.prototype.isFlex = function () {
    return getComputedStyle(this.list).display.indexOf("flex") !== -1;
  };

  Slider.prototype.isGrid = function () {
    return getComputedStyle(this.list).display.indexOf("grid") !== -1;
  };

  Slider.prototype.ensureSpacers = function () {
    var kids = Array.from(this.list.children);

    var className = this.conf.spacer
      ? this.conf.spacer.replace(/^[.#]/, "")
      : "awards-slider-spacer";

    var needStart = !(
      kids[0] &&
      kids[0].classList &&
      kids[0].classList.contains(className)
    );

    var needEnd = !(
      kids[kids.length - 1] &&
      kids[kids.length - 1].classList &&
      kids[kids.length - 1].classList.contains(className)
    );

    if (needStart) {
      var el = document.createElement("div");

      el.className = className;

      el.setAttribute("aria-hidden", "true");

      el.style.pointerEvents = "none";

      el.style.height = "1px";

      el.style.minHeight = "1px";

      if (this.isFlex()) {
        el.style.flex = "0 0 auto";
      }

      this.list.insertBefore(el, this.list.firstChild);
    }

    if (needEnd) {
      var el2 = document.createElement("div");

      el2.className = className;

      el2.setAttribute("aria-hidden", "true");

      el2.style.pointerEvents = "none";

      el2.style.height = "1px";

      el2.style.minHeight = "1px";

      if (this.isFlex()) {
        el2.style.flex = "0 0 auto";
      }

      this.list.appendChild(el2);
    }
  };

  Slider.prototype.resetEdgeItemMargins = function () {
    if (this.firstItem) {
      this.firstItem.style.marginLeft = "0px";
    }

    if (this.lastItem) {
      this.lastItem.style.marginRight = "0px";
    }
  };

  Slider.prototype.updateSpacers = function () {
    this.ensureSpacers();
    this.resetEdgeItemMargins();

    var kids = Array.from(this.list.children);

    var cls = this.conf.spacer
      ? this.conf.spacer.replace(/^[.#]/, "")
      : "awards-slider-spacer";

    var spacerStart =
      kids[0] && kids[0].classList.contains(cls) ? kids[0] : null;

    var spacerEnd =
      kids[kids.length - 1] && kids[kids.length - 1].classList.contains(cls)
        ? kids[kids.length - 1]
        : null;

    if (!spacerStart || !spacerEnd) {
      return;
    }

    var marginRef = this.pickVisibleMarginRef();

    var eps = this.devicePixelEpsilon();

    var gap = this.listGap();

    this._lastGapPx = gap;

    spacerStart.style.marginRight = "";

    spacerEnd.style.marginLeft = "";

    if (gap > 0.0001) {
      spacerStart.style.marginRight = "-" + gap + "px";

      spacerEnd.style.marginLeft = "-" + gap + "px";
    }

    if (!marginRef) {
      spacerStart.style.width = eps + "px";

      spacerEnd.style.width = eps + "px";

      this._lastGutterPx = eps;

      return;
    }

    var sRect = this.scroller.getBoundingClientRect();

    var rRect = marginRef.getBoundingClientRect();

    var scrollerCS = getComputedStyle(this.scroller);

    var listCS = getComputedStyle(this.list);

    var scrollerBorderL = parseFloat(scrollerCS.borderLeftWidth || "0") || 0;

    var scrollerPadL = parseFloat(scrollerCS.paddingLeft || "0") || 0;

    var listPadL = parseFloat(listCS.paddingLeft || "0") || 0;

    var scrollerInnerLeft = sRect.left + scrollerBorderL + scrollerPadL;

    var desiredLeft = rRect.left;

    var raw = desiredLeft - scrollerInnerLeft - listPadL;

    var width = raw <= 0 ? eps : Math.round(raw);

    spacerStart.style.width = width + "px";

    spacerEnd.style.width = width + "px";

    if (this.isGrid()) {
      spacerStart.style.justifySelf = "start";

      spacerEnd.style.justifySelf = "start";

      spacerStart.style.gridColumn = "auto";

      spacerEnd.style.gridColumn = "auto";
    }

    this._lastGutterPx = width;
  };

  Slider.prototype.maxScroll = function () {
    return Math.max(0, this.scroller.scrollWidth - this.scroller.clientWidth);
  };

  Slider.prototype.syncLenisDimensions = function (force) {
    if (!this.lenis || typeof this.lenis.resize !== "function") {
      return false;
    }

    var scrollWidth = Math.max(0, this.scroller.scrollWidth || 0);

    var clientWidth = Math.max(0, this.scroller.clientWidth || 0);

    var liveLimit = Math.max(0, scrollWidth - clientWidth);

    var lenisLimit = Number(this.lenis.limit);

    var dimensionsChanged =
      scrollWidth !== this._lastLenisScrollWidth ||
      clientWidth !== this._lastLenisClientWidth;

    var limitMismatch =
      !Number.isFinite(lenisLimit) || Math.abs(lenisLimit - liveLimit) > 1;

    if (force || dimensionsChanged || limitMismatch) {
      try {
        this.lenis.resize();
      } catch (e) {
        return false;
      }

      this._lastLenisScrollWidth = scrollWidth;
      this._lastLenisClientWidth = clientWidth;

      lenisLimit = Number(this.lenis.limit);
    } else {
      this._lastLenisScrollWidth = scrollWidth;
      this._lastLenisClientWidth = clientWidth;
    }

    return Number.isFinite(lenisLimit) && Math.abs(lenisLimit - liveLimit) <= 1;
  };

  Slider.prototype.getLiveScrollMetrics = function () {
    var scrollWidth = Math.max(0, this.scroller.scrollWidth || 0);

    var clientWidth = Math.max(0, this.scroller.clientWidth || 0);

    var max = Math.max(0, scrollWidth - clientWidth);

    var current = this.safeClampScroll(this.scroller.scrollLeft);

    var epsilon = this.scrollEdgeEpsilon();

    if (max <= 0 || scrollWidth <= clientWidth + epsilon) {
      return {
        current: 0,
        max: 0,
        progress: 0,
        progressPercent: 0,
        isAtStart: true,
        isAtEnd: true,
      };
    }

    var atStart = current <= epsilon;

    var atEnd =
      current >= max - epsilon ||
      current + clientWidth >= scrollWidth - epsilon;

    if (atStart) {
      current = 0;
    }

    if (atEnd) {
      current = max;
    }

    var progress = max > 0 ? clamp(current / max) : 0;

    if (atEnd) {
      progress = 1;
    }

    if (atStart) {
      progress = 0;
    }

    return {
      current: current,
      max: max,
      progress: progress,
      progressPercent: progress * 100,
      isAtStart: atStart,
      isAtEnd: atEnd,
    };
  };

  Slider.prototype.updateOverlays = function () {
    if (!this.overlayStart && !this.overlayEnd) {
      return;
    }

    var total = this.scroller.scrollWidth;

    var visible = this.scroller.clientWidth;

    var scrollable = total > visible + 1;

    function setVis(el, show) {
      if (!el) return;

      el.style.opacity = show ? "1" : "0";

      el.style.pointerEvents = show ? "" : "none";
    }

    if (!scrollable) {
      setVis(this.overlayStart, false);

      setVis(this.overlayEnd, false);

      return;
    }

    var metrics = this.getLiveScrollMetrics();

    setVis(this.overlayStart, !metrics.isAtStart);

    setVis(this.overlayEnd, !metrics.isAtEnd);
  };

  Slider.prototype.updateButtons = function () {
    if (!this.btnPrev && !this.btnNext) {
      return;
    }

    var total = this.scroller.scrollWidth;

    var visible = this.scroller.clientWidth;

    var scrollable = total > visible + 1;

    if (!scrollable) {
      if (this.btnPrev) {
        this.btnPrev.classList.add("inactive");

        this.btnPrev.style.display = "none";
      }

      if (this.btnNext) {
        this.btnNext.classList.add("inactive");

        this.btnNext.style.display = "none";
      }

      return;
    }

    if (this.btnPrev) {
      this.btnPrev.style.display = "";
    }

    if (this.btnNext) {
      this.btnNext.style.display = "";
    }

    var metrics = this.getLiveScrollMetrics();

    if (this.btnPrev) {
      if (metrics.isAtStart) {
        this.btnPrev.classList.add("inactive");
      } else {
        this.btnPrev.classList.remove("inactive");
      }
    }

    if (this.btnNext) {
      if (metrics.isAtEnd) {
        this.btnNext.classList.add("inactive");
      } else {
        this.btnNext.classList.remove("inactive");
      }
    }
  };

  Slider.prototype.computeScrollbarMetrics = function () {
    if (!this.scrollTrack || !this.scrollBar) {
      return null;
    }

    var total = this.scroller.scrollWidth;

    var visible = this.scroller.clientWidth;

    var items = this.list.querySelectorAll(this.conf.item).length;

    if (total <= visible || items === 0) {
      return null;
    }

    var trackWidth = this.scrollTrack.clientWidth;

    var avgItemWidth = total / Math.max(1, items + 2);

    var visibleItems = Math.max(1, Math.round(visible / avgItemWidth));

    var barWidth = Math.max(8, (visibleItems / (items + 2)) * trackWidth);

    var metrics = this.getLiveScrollMetrics();

    var maxS = Math.max(1, metrics.max);

    var maxX = Math.max(0, trackWidth - barWidth);

    var x = maxX * metrics.progress;

    return {
      trackWidth: trackWidth,
      barWidth: barWidth,
      maxS: maxS,
      maxX: maxX,
      x: x,
    };
  };

  Slider.prototype.updateScrollbar = function () {
    if (!this.scrollTrack || !this.scrollBar) {
      return;
    }

    var m = this.computeScrollbarMetrics();

    if (!m) {
      this.scrollTrack.style.display = "none";

      return;
    }

    this.scrollTrack.style.display = "";

    this.scrollBar.style.width = m.barWidth + "px";

    if (!this.draggingBar) {
      this.scrollBar.style.transform = "translateX(" + m.x + "px)";
    }
  };

  Slider.prototype.rafUpdate = function () {
    this.updateSpacers();
    this.syncLenisDimensions(false);
    this.updateScrollbar();
    this.updateButtons();
    this.updateOverlays();
    this.updateSlideState(false);
  };

  Slider.prototype.safeClampScroll = function (x) {
    var clamped = Math.min(Math.max(x, 0), this.maxScroll());

    return Number.isFinite(clamped) ? clamped : 0;
  };

  Slider.prototype.setScroll = function (x, opts) {
    var target = this.safeClampScroll(x);

    if (this.lenis && this.syncLenisDimensions(false)) {
      var o = opts || {};

      try {
        this.lenis.scrollTo(target, {
          immediate: !!o.immediate,

          lock: !!o.lock,

          force: o.force !== false,
        });
      } catch (e) {
        this.scroller.scrollLeft = target;
      }
    } else {
      this.scroller.scrollLeft = target;
    }

    this.updateScrollbar();
    this.updateButtons();
    this.updateOverlays();
    this.updateSlideState(false);
  };

  Slider.prototype.scheduleTouchClamp = function () {
    var self = this;

    if (this._touchClampTimer) {
      clearTimeout(this._touchClampTimer);
    }

    this._touchClampTimer = setTimeout(function () {
      self._touchClampTimer = 0;

      var cur = self.scroller.scrollLeft;

      var max = self.maxScroll();

      var clientWidth = Math.max(0, self.scroller.clientWidth || 0);

      var scrollWidth = Math.max(0, self.scroller.scrollWidth || 0);

      var eps = self.scrollEdgeEpsilon();

      if (!Number.isFinite(cur)) {
        self.scroller.scrollLeft = 0;
      } else if (cur < -eps || cur > max + eps) {
        self.scroller.scrollLeft = self.safeClampScroll(cur);
      } else if (cur < 0) {
        self.scroller.scrollLeft = 0;
      } else if (cur > max) {
        self.scroller.scrollLeft = max;
      } else if (cur <= eps) {
        self.scroller.scrollLeft = 0;
      } else if (cur + clientWidth >= scrollWidth - eps) {
        self.scroller.scrollLeft = max;
      }

      self.updateScrollbar();
      self.updateButtons();
      self.updateOverlays();
      self.updateSlideState(false);
    }, 90);
  };

  Slider.prototype.onScroll = function () {
    var self = this;

    if (!this.mq.matches) {
      this.updateScrollbar();
      this.updateButtons();
      this.updateOverlays();
      this.updateSlideState(false);
      this.scheduleTouchClamp();

      return;
    }

    if (this.ticking) {
      return;
    }

    this.ticking = true;

    requestAnimationFrame(function () {
      var clamped = self.safeClampScroll(self.scroller.scrollLeft);

      if (clamped !== self.scroller.scrollLeft) {
        if (self.lenis && self.syncLenisDimensions(false)) {
          self.setScroll(clamped, {
            immediate: true,
            lock: false,
            force: true,
          });
        } else {
          self.scroller.scrollLeft = clamped;
        }
      }

      self.updateScrollbar();
      self.updateButtons();
      self.updateOverlays();
      self.updateSlideState(false);

      self.ticking = false;
    });
  };

  Slider.prototype.itemStepWidth = function () {
    if (!this.conf.item) {
      return Math.max(1, Math.floor(this.scroller.clientWidth * 0.9));
    }

    var item = this.list.querySelector(this.conf.item);

    if (!item) {
      return Math.max(1, Math.floor(this.scroller.clientWidth * 0.9));
    }

    var cs = getComputedStyle(item);

    var w = item.getBoundingClientRect().width;

    var mr = parseFloat(cs.marginRight) || 0;

    return Math.max(1, Math.round(w + mr));
  };

  Slider.prototype.getAlignTargetLeft = function () {
    var ref = this.pickVisibleMarginRef();

    if (ref) {
      return ref.getBoundingClientRect().left;
    }

    var sRect = this.scroller.getBoundingClientRect();

    var scrollerCS = getComputedStyle(this.scroller);

    var listCS = getComputedStyle(this.list);

    var scrollerBorderL = parseFloat(scrollerCS.borderLeftWidth || "0") || 0;

    var scrollerPadL = parseFloat(scrollerCS.paddingLeft || "0") || 0;

    var listPadL = parseFloat(listCS.paddingLeft || "0") || 0;

    var gutter = Number.isFinite(this._lastGutterPx) ? this._lastGutterPx : 0;

    return sRect.left + scrollerBorderL + scrollerPadL + listPadL + gutter;
  };

  Slider.prototype.getOrderedItems = function () {
    if (!this.conf.item) {
      return [];
    }

    var nodes = Array.from(this.list.querySelectorAll(this.conf.item));

    return nodes.filter(function (n) {
      return n && n.nodeType === 1;
    });
  };

  Slider.prototype.getCurrentItemIndex = function (items) {
    if (!items || !items.length) {
      return -1;
    }

    var alignLeft = this.getAlignTargetLeft();

    var bestIdx = 0;
    var bestAbs = Infinity;

    for (var i = 0; i < items.length; i++) {
      var r = items[i].getBoundingClientRect();

      var d = r.left - alignLeft;

      var ad = Math.abs(d);

      if (ad < bestAbs) {
        bestAbs = ad;

        bestIdx = i;
      }
    }

    return bestIdx;
  };

  Slider.prototype.getItemAnchorScrolls = function (items) {
    var metrics = this.getLiveScrollMetrics();

    var current = metrics.current;

    var alignLeft = this.getAlignTargetLeft();

    var anchors = [];
    var last = -Infinity;

    for (var i = 0; i < items.length; i++) {
      var item = items[i];

      item.setAttribute("data-rt-slider-item-index", String(i));

      var rect = item.getBoundingClientRect();

      var raw = current + (rect.left - alignLeft);

      var anchor = this.safeClampScroll(raw);

      if (anchor < last) {
        anchor = last;
      }

      anchors.push(anchor);

      last = anchor;
    }

    if (anchors.length) {
      var max = this.maxScroll();

      var eps = this.scrollEdgeEpsilon();

      if (anchors[0] <= eps) {
        anchors[0] = 0;
      }

      if (anchors[anchors.length - 1] >= max - eps) {
        anchors[anchors.length - 1] = max;
      }
    }

    return anchors;
  };

  Slider.prototype.cloneSlideState = function (state) {
    if (!state) {
      return null;
    }

    return {
      sliderId: state.sliderId,

      itemCount: state.itemCount,

      scroll: {
        current: state.scroll.current,

        max: state.scroll.max,

        progress: state.scroll.progress,

        progressPercent: state.scroll.progressPercent,

        direction: state.scroll.direction,

        isAtStart: state.scroll.isAtStart,

        isAtEnd: state.scroll.isAtEnd,
      },

      active: {
        index: state.active.index,

        element: state.active.element,

        anchorScrollLeft: state.active.anchorScrollLeft,

        distancePx: state.active.distancePx,
      },

      previous: {
        index: state.previous.index,

        element: state.previous.element,
      },

      next: {
        index: state.next.index,

        element: state.next.element,
      },

      segment: {
        fromIndex: state.segment.fromIndex,

        fromElement: state.segment.fromElement,

        toIndex: state.segment.toIndex,

        toElement: state.segment.toElement,

        progress: state.segment.progress,

        progressPercent: state.segment.progressPercent,

        distancePx: state.segment.distancePx,

        spanPx: state.segment.spanPx,

        remainingPx: state.segment.remainingPx,

        isBetween: state.segment.isBetween,
      },

      slides: state.slides.map(function (slide) {
        return {
          index: slide.index,

          element: slide.element,

          anchorScrollLeft: slide.anchorScrollLeft,

          anchorProgress: slide.anchorProgress,

          anchorProgressPercent: slide.anchorProgressPercent,

          distanceFromCurrentPx: slide.distanceFromCurrentPx,

          isActive: slide.isActive,

          isPrevious: slide.isPrevious,

          isNext: slide.isNext,

          isFrom: slide.isFrom,

          isTo: slide.isTo,

          isBeforeActive: slide.isBeforeActive,

          isAfterActive: slide.isAfterActive,
        };
      }),
    };
  };

  Slider.prototype.cloneScrollState = function (scroll) {
    if (!scroll) {
      return null;
    }

    return {
      current: scroll.current,

      max: scroll.max,

      progress: scroll.progress,

      progressPercent: scroll.progressPercent,

      direction: scroll.direction,

      isAtStart: scroll.isAtStart,

      isAtEnd: scroll.isAtEnd,
    };
  };

  Slider.prototype.dispatchSliderEvent = function (name, detail) {
    var payload = this.cloneSlideState(detail);

    try {
      this.root.dispatchEvent(
        new CustomEvent(name, {
          bubbles: true,
          detail: payload,
        }),
      );
    } catch (e) {
      var ev = document.createEvent("CustomEvent");

      ev.initCustomEvent(name, true, false, payload);

      this.root.dispatchEvent(ev);
    }
  };

  Slider.prototype.dispatchProgressEvent = function (name, detail) {
    var payload = this.cloneScrollState(detail);

    try {
      this.root.dispatchEvent(
        new CustomEvent(name, {
          bubbles: true,
          detail: payload,
        }),
      );
    } catch (e) {
      var ev = document.createEvent("CustomEvent");

      ev.initCustomEvent(name, true, false, payload);

      this.root.dispatchEvent(ev);
    }
  };

  Slider.prototype.applySlideStateAttributes = function (state) {
    var root = this.root;

    root.setAttribute(
      "data-rt-slider-active-index",
      String(state.active.index),
    );

    root.setAttribute(
      "data-rt-slider-from-index",
      String(state.segment.fromIndex),
    );

    root.setAttribute("data-rt-slider-to-index", String(state.segment.toIndex));

    root.setAttribute(
      "data-rt-slider-segment-progress",
      String(round(state.segment.progress, 6)),
    );

    root.setAttribute(
      "data-rt-slider-segment-progress-percent",
      String(round(state.segment.progressPercent, 4)),
    );

    root.setAttribute(
      "data-rt-slider-scroll-current",
      String(round(state.scroll.current, 4)),
    );

    root.setAttribute(
      "data-rt-slider-scroll-max",
      String(round(state.scroll.max, 4)),
    );

    root.setAttribute(
      "data-rt-slider-scroll-progress",
      String(round(state.scroll.progress, 6)),
    );

    root.setAttribute(
      "data-rt-slider-scroll-progress-percent",
      String(round(state.scroll.progressPercent, 4)),
    );

    root.setAttribute(
      "data-rt-slider-scroll-direction",
      state.scroll.direction,
    );

    root.setAttribute(
      "data-rt-slider-scroll-at-start",
      state.scroll.isAtStart ? "true" : "false",
    );

    root.setAttribute(
      "data-rt-slider-scroll-at-end",
      state.scroll.isAtEnd ? "true" : "false",
    );

    for (var i = 0; i < state.slides.length; i++) {
      var slide = state.slides[i];

      var el = slide.element;

      if (!el) {
        continue;
      }

      el.setAttribute("data-rt-slider-item-index", String(slide.index));

      el.setAttribute(
        "data-rt-slider-item-active",
        slide.isActive ? "true" : "false",
      );

      el.setAttribute(
        "data-rt-slider-item-from",
        slide.isFrom ? "true" : "false",
      );

      el.setAttribute("data-rt-slider-item-to", slide.isTo ? "true" : "false");

      el.setAttribute(
        "data-rt-slider-item-previous",
        slide.isPrevious ? "true" : "false",
      );

      el.setAttribute(
        "data-rt-slider-item-next",
        slide.isNext ? "true" : "false",
      );

      el.setAttribute(
        "data-rt-slider-item-before-active",
        slide.isBeforeActive ? "true" : "false",
      );

      el.setAttribute(
        "data-rt-slider-item-after-active",
        slide.isAfterActive ? "true" : "false",
      );

      el.setAttribute(
        "data-rt-slider-item-anchor-progress",
        String(round(slide.anchorProgress, 6)),
      );

      el.setAttribute(
        "data-rt-slider-item-anchor-progress-percent",
        String(round(slide.anchorProgressPercent, 4)),
      );

      el.setAttribute(
        "data-rt-slider-item-distance",
        String(round(slide.distanceFromCurrentPx, 4)),
      );
    }
  };

  Slider.prototype.buildSlideState = function () {
    var items = this.getOrderedItems();

    var metrics = this.getLiveScrollMetrics();

    var max = metrics.max;

    var current = metrics.current;

    var prevScroll = this._lastSlideStateScrollLeft;

    var scrollDirection = "none";

    if (current > prevScroll + 0.01) {
      scrollDirection = "forward";
    } else if (current < prevScroll - 0.01) {
      scrollDirection = "backward";
    }

    if (!items.length) {
      return {
        sliderId: this.sliderId,

        itemCount: 0,

        scroll: {
          current: current,

          max: max,

          progress: metrics.progress,

          progressPercent: metrics.progressPercent,

          direction: scrollDirection,

          isAtStart: metrics.isAtStart,

          isAtEnd: metrics.isAtEnd,
        },

        active: {
          index: -1,
          element: null,
          anchorScrollLeft: 0,
          distancePx: 0,
        },

        previous: {
          index: -1,
          element: null,
        },

        next: {
          index: -1,
          element: null,
        },

        segment: {
          fromIndex: -1,
          fromElement: null,
          toIndex: -1,
          toElement: null,
          progress: 0,
          progressPercent: 0,
          distancePx: 0,
          spanPx: 0,
          remainingPx: 0,
          isBetween: false,
        },

        slides: [],
      };
    }

    var anchors = this.getItemAnchorScrolls(items);

    var nearestIndex = 0;

    var nearestDistance = Infinity;

    for (var i = 0; i < anchors.length; i++) {
      var distance = current - anchors[i];

      var absDistance = Math.abs(distance);

      if (absDistance < nearestDistance) {
        nearestDistance = absDistance;

        nearestIndex = i;
      }
    }

    var fromIndex = 0;

    var toIndex = 0;

    var segmentProgress = 0;

    var segmentDistance = 0;

    var segmentSpan = 0;

    var segmentRemaining = 0;

    var isBetween = false;

    if (current <= anchors[0]) {
      fromIndex = 0;
      toIndex = 0;
      segmentProgress = 0;
      segmentDistance = 0;
      segmentSpan = 0;
      segmentRemaining = 0;
      isBetween = false;
    } else if (current >= anchors[anchors.length - 1]) {
      fromIndex = anchors.length - 1;

      toIndex = anchors.length - 1;

      segmentProgress = 1;
      segmentDistance = 0;
      segmentSpan = 0;
      segmentRemaining = 0;
      isBetween = false;
    } else {
      for (var j = 0; j < anchors.length - 1; j++) {
        var a = anchors[j];

        var b = anchors[j + 1];

        if (current >= a && current <= b) {
          fromIndex = j;
          toIndex = j + 1;

          segmentSpan = Math.max(0, b - a);

          segmentDistance = Math.max(0, current - a);

          segmentProgress =
            segmentSpan > 0 ? clamp(segmentDistance / segmentSpan) : 0;

          segmentRemaining = Math.max(0, segmentSpan - segmentDistance);

          isBetween = current > a && current < b;

          break;
        }
      }
    }

    var slides = [];

    for (var k = 0; k < items.length; k++) {
      var anchor = anchors[k];

      var anchorProgress = max > 0 ? clamp(anchor / max) : 0;

      slides.push({
        index: k,

        element: items[k],

        anchorScrollLeft: anchor,

        anchorProgress: anchorProgress,

        anchorProgressPercent: anchorProgress * 100,

        distanceFromCurrentPx: current - anchor,

        isActive: k === nearestIndex,

        isPrevious: k === nearestIndex - 1,

        isNext: k === nearestIndex + 1,

        isFrom: k === fromIndex,

        isTo: k === toIndex,

        isBeforeActive: k < nearestIndex,

        isAfterActive: k > nearestIndex,
      });
    }

    return {
      sliderId: this.sliderId,

      itemCount: items.length,

      scroll: {
        current: current,

        max: max,

        progress: metrics.progress,

        progressPercent: metrics.progressPercent,

        direction: scrollDirection,

        isAtStart: metrics.isAtStart,

        isAtEnd: metrics.isAtEnd,
      },

      active: {
        index: nearestIndex,

        element: items[nearestIndex] || null,

        anchorScrollLeft: anchors[nearestIndex] || 0,

        distancePx: current - (anchors[nearestIndex] || 0),
      },

      previous: {
        index: nearestIndex > 0 ? nearestIndex - 1 : -1,

        element: nearestIndex > 0 ? items[nearestIndex - 1] : null,
      },

      next: {
        index: nearestIndex < items.length - 1 ? nearestIndex + 1 : -1,

        element:
          nearestIndex < items.length - 1 ? items[nearestIndex + 1] : null,
      },

      segment: {
        fromIndex: fromIndex,

        fromElement: items[fromIndex] || null,

        toIndex: toIndex,

        toElement: items[toIndex] || null,

        progress: segmentProgress,

        progressPercent: segmentProgress * 100,

        distancePx: segmentDistance,

        spanPx: segmentSpan,

        remainingPx: segmentRemaining,

        isBetween: isBetween,
      },

      slides: slides,
    };
  };

  Slider.prototype.updateSlideState = function (force) {
    var state = this.buildSlideState();

    var prevActiveIndex = this._lastSlideStateActiveIndex;

    var sig =
      state.active.index +
      "|" +
      state.segment.fromIndex +
      "|" +
      state.segment.toIndex +
      "|" +
      round(state.segment.progress, 4) +
      "|" +
      round(state.scroll.progress, 4) +
      "|" +
      state.scroll.direction;

    var progressSig =
      round(state.scroll.progress, 6) +
      "|" +
      round(state.scroll.current, 4) +
      "|" +
      round(state.scroll.max, 4) +
      "|" +
      state.scroll.direction +
      "|" +
      (state.scroll.isAtStart ? "1" : "0") +
      "|" +
      (state.scroll.isAtEnd ? "1" : "0");

    this.slideState = state;

    this.applySlideStateAttributes(state);

    this._lastSlideStateScrollLeft = state.scroll.current;

    if (force || progressSig !== this._progressSig) {
      this._progressSig = progressSig;

      this.dispatchProgressEvent("rtSlider:progress", state.scroll);
    }

    if (force || sig !== this._slideStateSig) {
      this._slideStateSig = sig;

      this.dispatchSliderEvent("rtSlider:slide", state);
    }

    if (force || state.active.index !== prevActiveIndex) {
      this._lastSlideStateActiveIndex = state.active.index;

      this.dispatchSliderEvent("rtSlider:active", state);
    }
  };

  Slider.prototype.getSlideState = function () {
    if (!this.slideState) {
      this.updateSlideState(true);
    }

    return this.cloneSlideState(this.slideState);
  };

  Slider.prototype.getScrollState = function () {
    var state = this.getSlideState();

    return state ? this.cloneScrollState(state.scroll) : null;
  };

  Slider.prototype.getProgress = function () {
    var scroll = this.getScrollState();

    return scroll ? scroll.progress : 0;
  };

  Slider.prototype.getActiveIndex = function () {
    var state = this.getSlideState();

    return state && state.active ? state.active.index : -1;
  };

  Slider.prototype.getActiveElement = function () {
    var state = this.getSlideState();

    return state && state.active ? state.active.element : null;
  };

  Slider.prototype.scrollAlignToItem = function (el) {
    if (!el) return;

    var total = this.scroller.scrollWidth;

    var visible = this.scroller.clientWidth;

    if (total <= visible + 1) {
      return;
    }

    var alignLeft = this.getAlignTargetLeft();

    var r = el.getBoundingClientRect();

    var delta = r.left - alignLeft;

    if (!Number.isFinite(delta)) {
      return;
    }

    var target = this.safeClampScroll(this.scroller.scrollLeft + delta);

    if (this.lenis && this.syncLenisDimensions(false)) {
      var duration = 1.2;

      try {
        this.lenis.scrollTo(target, {
          duration: duration,

          easing: function (t) {
            return Math.min(1, 1.001 - Math.pow(2, -10 * t));
          },

          immediate: false,

          lock: false,

          force: true,
        });
      } catch (e) {
        this.scroller.scrollTo({
          left: target,

          behavior: "smooth",
        });
      }
    } else {
      this.scroller.scrollTo({
        left: target,

        behavior: "smooth",
      });
    }
  };

  Slider.prototype.scrollByItems = function (n) {
    var total = this.scroller.scrollWidth;

    var visible = this.scroller.clientWidth;

    if (total <= visible + 1) {
      return;
    }

    var items = this.getOrderedItems();

    if (!items.length) {
      var step = this.itemStepWidth();

      var fallback =
        n > 0
          ? this.scroller.scrollLeft + step * n
          : this.scroller.scrollLeft - step * Math.abs(n);

      var clamped = this.safeClampScroll(fallback);

      if (this.lenis && this.syncLenisDimensions(false)) {
        try {
          this.lenis.scrollTo(clamped, {
            duration: 1.2,

            easing: function (t) {
              return Math.min(1, 1.001 - Math.pow(2, -10 * t));
            },

            immediate: false,

            lock: false,

            force: true,
          });
        } catch (e) {
          this.scroller.scrollTo({
            left: clamped,

            behavior: "smooth",
          });
        }
      } else {
        this.scroller.scrollTo({
          left: clamped,

          behavior: "smooth",
        });
      }

      return;
    }

    var curIdx = this.getCurrentItemIndex(items);

    if (curIdx < 0) {
      curIdx = 0;
    }

    var nextIdx = curIdx;

    if (n > 0) {
      nextIdx = Math.min(items.length - 1, curIdx + 1);
    } else if (n < 0) {
      nextIdx = Math.max(0, curIdx - 1);
    }

    this.scrollAlignToItem(items[nextIdx]);
  };

  Slider.prototype.onPrevClick = function (e) {
    e.preventDefault();

    this.scrollByItems(-1);
  };

  Slider.prototype.onNextClick = function (e) {
    e.preventDefault();

    this.scrollByItems(1);
  };

  Slider.prototype.stopInertia = function () {
    if (this.inertiaId) {
      cancelAnimationFrame(this.inertiaId);

      this.inertiaId = 0;
    }
  };

  Slider.prototype.startDrag = function (e) {
    if (this.dragging) {
      return;
    }

    this.dragging = true;
    this.didDrag = true;

    this.didDragTs = performance.now();

    this.dragMovedPx = Math.max(
      this.dragMovedPx,
      Math.abs(e.clientX - this.startX),
    );

    if (this.lenis) {
      this.syncLenisDimensions(false);

      try {
        this.lenis.stop();

        this._lenisWasStopped = true;
      } catch (err) {
        this._lenisWasStopped = false;
      }
    }

    try {
      this.scroller.setPointerCapture(e.pointerId);
    } catch (err) {}

    this.scroller.classList.add("is-dragging");

    this.scroller.style.userSelect = "none";

    this.stopInertia();

    this.lastX = e.clientX;

    this.lastT = performance.now();

    this.velocity = 0;
  };

  Slider.prototype.endDrag = function (e) {
    if (!this.dragging) {
      return;
    }

    this.dragging = false;

    this.scroller.classList.remove("is-dragging");

    this.scroller.style.userSelect = "";

    if (e && e.pointerId != null) {
      try {
        this.scroller.releasePointerCapture(e.pointerId);
      } catch (err) {}
    }

    var minVel = 0.2;

    if (this.lenis) {
      if (this._lenisWasStopped) {
        try {
          this.lenis.start();
        } catch (err) {}
      }

      this._lenisWasStopped = false;

      var lenisReady = this.syncLenisDimensions(false);

      if (lenisReady) {
        if (Math.abs(this.velocity) >= minVel) {
          var throwDist = this.velocity * 24;

          var target = this.safeClampScroll(
            this.scroller.scrollLeft + throwDist,
          );

          var speed = Math.min(
            2.0,
            Math.max(0.35, Math.abs(this.velocity) / 18),
          );

          var duration = Math.min(1.35, Math.max(0.35, 0.85 / speed));

          try {
            this.lenis.scrollTo(target, {
              duration: duration,

              easing: function (t) {
                return Math.min(1, 1.001 - Math.pow(2, -10 * t));
              },

              immediate: false,

              lock: false,

              force: true,
            });
          } catch (err) {
            this.scroller.scrollTo({
              left: target,

              behavior: "smooth",
            });
          }
        }

        return;
      }
    }

    var decay = 0.92;

    var self = this;

    var step = function () {
      var next = self.safeClampScroll(self.scroller.scrollLeft + self.velocity);

      self.scroller.scrollLeft = next;

      self.velocity *= decay;

      var atEdge = next <= 0 || next >= self.maxScroll();

      if (Math.abs(self.velocity) < minVel || atEdge) {
        self.inertiaId = 0;

        return;
      }

      self.inertiaId = requestAnimationFrame(step);
    };

    if (Math.abs(this.velocity) >= minVel) {
      this.inertiaId = requestAnimationFrame(step);
    }
  };

  Slider.prototype.onPointerDown = function (e) {
    if (this.lenis) {
      this.syncLenisDimensions(false);
    }

    var total = this.scroller.scrollWidth;

    var visible = this.scroller.clientWidth;

    if (total <= visible + 1) {
      return;
    }

    if (e.pointerType === "mouse" && e.button !== 0) {
      return;
    }

    this.maybeDrag = true;

    this.dragging = false;

    this.didDrag = false;

    this.didDragTs = 0;

    this.dragMovedPx = 0;

    this.startX = e.clientX;

    this.startScroll = this.scroller.scrollLeft;

    this.lastX = e.clientX;

    this.lastT = performance.now();

    this.velocity = 0;
  };

  Slider.prototype.onPointerMove = function (e) {
    if (!this.maybeDrag && !this.dragging) {
      return;
    }

    var dxFromStart = e.clientX - this.startX;

    this.dragMovedPx = Math.max(this.dragMovedPx, Math.abs(dxFromStart));

    if (!this.dragging) {
      if (Math.abs(dxFromStart) >= 6) {
        this.startDrag(e);
      } else {
        return;
      }
    }

    var now = performance.now();

    var dx = e.clientX - this.lastX;

    var dt = Math.max(1, now - this.lastT);

    var target = this.startScroll - (e.clientX - this.startX);

    this.setScroll(target, {
      immediate: true,
      lock: true,
      force: true,
    });

    this.velocity = -(dx / dt) * 16;

    this.lastX = e.clientX;

    this.lastT = now;
  };

  Slider.prototype.onPointerUp = function (e) {
    var self = this;

    if (this.dragging) {
      this.endDrag(e);
    }

    this.maybeDrag = false;

    if (this.dragMovedPx < 6) {
      this.didDrag = false;

      this.didDragTs = 0;
    } else {
      this.didDrag = true;

      this.didDragTs = performance.now();
    }

    setTimeout(function () {
      self.didDrag = false;

      self.didDragTs = 0;

      self.dragMovedPx = 0;
    }, 420);
  };

  Slider.prototype.onPointerCancel = function () {
    var self = this;

    if (this.dragging) {
      this.dragging = false;

      this.scroller.classList.remove("is-dragging");

      this.scroller.style.userSelect = "";

      this.stopInertia();

      if (this.lenis && this._lenisWasStopped) {
        try {
          this.lenis.start();
        } catch (e) {}
      }

      this._lenisWasStopped = false;
    }

    this.maybeDrag = false;

    setTimeout(function () {
      self.didDrag = false;

      self.didDragTs = 0;

      self.dragMovedPx = 0;
    }, 0);
  };

  Slider.prototype.trackMetrics = function () {
    if (!this.scrollTrack || !this.scrollBar) {
      return {
        trackWidth: 0,
        barWidth: 0,
        maxX: 0,
        m: Math.max(1, this.maxScroll()),
      };
    }

    var trackWidth = this.scrollTrack.clientWidth;

    var m = Math.max(1, this.maxScroll());

    var barWidth = 0;

    var computed = this.computeScrollbarMetrics();

    if (computed) {
      barWidth = computed.barWidth;
    } else {
      barWidth = this.scrollBar.getBoundingClientRect().width || 0;
    }

    var maxX = Math.max(0, trackWidth - barWidth);

    return {
      trackWidth: trackWidth,

      barWidth: barWidth,

      maxX: maxX,

      m: m,
    };
  };

  Slider.prototype.setScrollFromTrackX = function (x, opts) {
    var met = this.trackMetrics();

    var nx = Math.min(Math.max(x, 0), met.maxX);

    if (this.scrollBar) {
      this.scrollBar.style.transform = "translateX(" + nx + "px)";
    }

    var progress = met.maxX === 0 ? 0 : nx / met.maxX;

    var target = progress * met.m;

    this.setScroll(
      target,
      opts || {
        immediate: true,
        lock: true,
        force: true,
      },
    );
  };

  Slider.prototype.startBarDrag = function (e) {
    if (!this.scrollTrack || !this.scrollBar) {
      return;
    }

    if (e.pointerType === "mouse" && e.button !== 0) {
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    if (this.lenis) {
      this.syncLenisDimensions(false);

      try {
        this.lenis.stop();

        this._lenisWasStopped = true;
      } catch (err) {
        this._lenisWasStopped = false;
      }
    }

    this.draggingBar = true;

    this.barPointerId = e.pointerId != null ? e.pointerId : null;

    var barRect = this.scrollBar.getBoundingClientRect();

    this.barOffsetX = e.clientX - barRect.left;

    this.scrollBar.style.cursor = "grabbing";

    this.scrollTrack.style.cursor = "grabbing";

    try {
      this.scrollTrack.setPointerCapture(e.pointerId);
    } catch (err) {}

    var trackRect = this.scrollTrack.getBoundingClientRect();

    var x = e.clientX - trackRect.left - this.barOffsetX;

    this.setScrollFromTrackX(x, {
      immediate: true,
      lock: true,
      force: true,
    });
  };

  Slider.prototype.onTrackPointerDown = function (e) {
    if (!this.scrollTrack || !this.scrollBar) {
      return;
    }

    this.updateScrollbar();
    this.startBarDrag(e);
  };

  Slider.prototype.onTrackPointerMove = function (e) {
    if (!this.draggingBar || !this.scrollTrack) {
      return;
    }

    if (
      this.barPointerId != null &&
      e.pointerId != null &&
      e.pointerId !== this.barPointerId
    ) {
      return;
    }

    e.preventDefault();

    var trackRect = this.scrollTrack.getBoundingClientRect();

    var x = e.clientX - trackRect.left - this.barOffsetX;

    this.setScrollFromTrackX(x, {
      immediate: true,
      lock: true,
      force: true,
    });
  };

  Slider.prototype.endBarDrag = function (e) {
    if (!this.draggingBar) {
      return;
    }

    this.draggingBar = false;

    if (this.scrollBar) {
      this.scrollBar.style.cursor = "grab";
    }

    if (this.scrollTrack) {
      this.scrollTrack.style.cursor = "pointer";
    }

    if (this.scrollTrack && e && e.pointerId != null) {
      try {
        this.scrollTrack.releasePointerCapture(e.pointerId);
      } catch (err) {}
    }

    if (this.lenis && this._lenisWasStopped) {
      try {
        this.lenis.start();
      } catch (err) {}
    }

    this._lenisWasStopped = false;

    this.syncLenisDimensions(false);

    this.updateScrollbar();
    this.updateButtons();
    this.updateOverlays();
    this.updateSlideState(false);

    this.barPointerId = null;
  };

  Slider.prototype.detectLinksInItems = function () {
    if (!this.conf.item) {
      return false;
    }

    return !!this.list.querySelector(this.conf.item + " a[href]");
  };

  Slider.prototype.clearCursorBindings = function () {
    for (var i = 0; i < this.cursorBindings.length; i++) {
      var b = this.cursorBindings[i];

      b.el.removeEventListener(b.type, b.fn);
    }

    this.cursorBindings = [];
  };

  Slider.prototype.setupCursorMode = function () {
    this.clearCursorBindings();

    var total = this.scroller.scrollWidth;

    var visible = this.scroller.clientWidth;

    var scrollable = total > visible + 1;

    if (!scrollable) {
      this.scroller.style.cursor = "";

      return;
    }

    if (!this.mq.matches) {
      this.scroller.style.cursor = "";

      return;
    }

    this.hasLinks = this.detectLinksInItems();

    if (this.hasLinks) {
      this.scroller.style.cursor = "";

      return;
    }

    var self = this;

    var onEnter = function () {
      if (!self.scroller.classList.contains("is-dragging")) {
        self.scroller.style.cursor = "grab";
      }
    };

    var onLeave = function () {
      self.scroller.style.cursor = "";
    };

    this.scroller.addEventListener("mouseenter", onEnter);

    this.scroller.addEventListener("mouseleave", onLeave);

    this.cursorBindings.push({
      el: this.scroller,

      type: "mouseenter",

      fn: onEnter,
    });

    this.cursorBindings.push({
      el: this.scroller,

      type: "mouseleave",

      fn: onLeave,
    });
  };

  Slider.prototype.captureBasePaddingBottomOnce = function () {
    if (this._basePaddingCaptured) {
      return;
    }

    var cs = getComputedStyle(this.scroller);

    var pb = parseFloat(cs.paddingBottom || "0") || 0;

    this._basePaddingBottomPx = pb;

    this._basePaddingCaptured = true;
  };

  Slider.prototype.applyIOSScrollIndicatorMask = function () {
    if (!this._basePaddingCaptured) {
      this.captureBasePaddingBottomOnce();
    }

    if (this.mq.matches) {
      this.scroller.style.removeProperty("--rt-slider-mask-bg");

      this.scroller.style.removeProperty("--rt-slider-mask-h");

      this.scroller.style.removeProperty("--rt-slider-base-pb");

      return;
    }

    var bg = findNearestOpaqueBgColor(this.scroller);

    this.scroller.style.setProperty("--rt-slider-mask-bg", bg);

    this.scroller.style.setProperty("--rt-slider-mask-h", "12px");

    this.scroller.style.setProperty(
      "--rt-slider-base-pb",
      (this._basePaddingBottomPx || 0) + "px",
    );
  };

  Slider.prototype.applyListStyles = function () {
    var listUID = assignUID(this.list, "data-rt-slider-list-uid");

    var scrollerUID = assignUID(this.scroller, "data-rt-slider-scroller-uid");

    var isDesktop = this.mq.matches;

    var scrollbarStyles = "";

    if (this.scrollTrack && this.scrollBar) {
      var trackUID = assignUID(this.scrollTrack, "data-rt-slider-track-uid");

      var barUID = assignUID(this.scrollBar, "data-rt-slider-bar-uid");

      if (isDesktop) {
        scrollbarStyles =
          '[data-rt-slider-track-uid="' +
          trackUID +
          '"]{position:relative; touch-action:none; overflow: visible !important;}' +
          '[data-rt-slider-track-uid="' +
          trackUID +
          '"]::before{content:"";position:absolute;top:-30px;bottom:-30px;left:0;right:0;z-index:0; cursor:pointer; pointer-events:auto;}' +
          '[data-rt-slider-bar-uid="' +
          barUID +
          '"]{position:relative; z-index:2; touch-action:none;}' +
          '[data-rt-slider-bar-uid="' +
          barUID +
          '"]::after{content:"";position:absolute;top:-30px;bottom:-30px;left:0;right:0;z-index:3; cursor:grab; pointer-events:auto;}';
      } else {
        scrollbarStyles =
          '[data-rt-slider-track-uid="' +
          trackUID +
          '"]{position:relative; touch-action:auto; overflow: visible !important; pointer-events:none !important; user-select:none !important;}' +
          '[data-rt-slider-track-uid="' +
          trackUID +
          '"]::before{content:"";position:absolute;top:-30px;bottom:-30px;left:0;right:0;z-index:0; pointer-events:none !important;}' +
          '[data-rt-slider-bar-uid="' +
          barUID +
          '"]{position:relative; z-index:2; touch-action:auto; pointer-events:none !important; user-select:none !important;}' +
          '[data-rt-slider-bar-uid="' +
          barUID +
          '"]::after{content:"";position:absolute;top:-30px;bottom:-30px;left:0;right:0;z-index:3; pointer-events:none !important;}';
      }
    }

    var hideNativeScrollbarCSS =
      '[data-rt-slider-list-uid="' +
      listUID +
      '"]::-webkit-scrollbar{width:0 !important;height:0 !important;display:none !important;background:transparent !important;}' +
      '[data-rt-slider-list-uid="' +
      listUID +
      '"]::-webkit-scrollbar-thumb{background:transparent !important;}' +
      '[data-rt-slider-list-uid="' +
      listUID +
      '"]::-webkit-scrollbar-track{background:transparent !important;}' +
      '[data-rt-slider-list-uid="' +
      listUID +
      '"]{scrollbar-width:none !important;-ms-overflow-style:none !important;}' +
      '[data-rt-slider-scroller-uid="' +
      scrollerUID +
      '"]::-webkit-scrollbar{width:0 !important;height:0 !important;display:none !important;background:transparent !important;}' +
      '[data-rt-slider-scroller-uid="' +
      scrollerUID +
      '"]::-webkit-scrollbar-thumb{background:transparent !important;}' +
      '[data-rt-slider-scroller-uid="' +
      scrollerUID +
      '"]::-webkit-scrollbar-track{background:transparent !important;}' +
      '[data-rt-slider-scroller-uid="' +
      scrollerUID +
      '"]{scrollbar-width:none !important;-ms-overflow-style:none !important;}';

    var iosMaskCSS = isDesktop
      ? ""
      : '[data-rt-slider-scroller-uid="' +
        scrollerUID +
        '"]{position:relative;padding-bottom:calc(var(--rt-slider-base-pb, 0px) + var(--rt-slider-mask-h, 12px));}' +
        '[data-rt-slider-scroller-uid="' +
        scrollerUID +
        '"]::after{content:"";position:absolute;left:0;right:0;bottom:0;height:var(--rt-slider-mask-h, 12px);pointer-events:none;z-index:2147483647;background:var(--rt-slider-mask-bg, transparent);}';

    var draggingCSS =
      '[data-rt-slider-scroller-uid="' +
      scrollerUID +
      '"].is-dragging{cursor:grabbing !important;user-select:none}' +
      '[data-rt-slider-list-uid="' +
      listUID +
      '"].is-dragging{cursor:grabbing !important;user-select:none}' +
      '[data-rt-slider-scroller-uid="' +
      scrollerUID +
      '"].is-dragging img,[data-rt-slider-scroller-uid="' +
      scrollerUID +
      '"].is-dragging a,[data-rt-slider-scroller-uid="' +
      scrollerUID +
      '"].is-dragging ' +
      this.conf.item +
      "{user-select:none;-webkit-user-drag:none}" +
      '[data-rt-slider-list-uid="' +
      listUID +
      '"] img{-webkit-user-drag:none}';

    this._injectedKey = "rt-ss-" + listUID;

    injectOnce(
      this._injectedKey,
      hideNativeScrollbarCSS + draggingCSS + scrollbarStyles + iosMaskCSS,
    );
  };

  Slider.prototype.onResize = function () {
    this.stopInertia();
    this.rafUpdate();
    this.setupCursorMode();
    this.applyIOSScrollIndicatorMask();
    this.applyListStyles();
    this.updateSlideState(true);

    this.scheduleLayoutSettle(1200);
  };

  Slider.prototype.onClickCapture = function (e) {
    if (!this.didDragTs) {
      return;
    }

    if (performance.now() - this.didDragTs > 420) {
      return;
    }

    var a =
      e.target && e.target.closest
        ? e.target.closest(
            "a,button,[role='button'],input,textarea,select,label",
          )
        : null;

    if (!a) {
      return;
    }

    e.preventDefault();
    e.stopPropagation();
  };

  Slider.prototype.getLenisOptions = function () {
    var prefix = "data-rt-slider-";

    var el = this.root;

    function getAttr(name) {
      return el.getAttribute(prefix + name);
    }

    var options = {
      wrapper: this.scroller,

      content: this.list,

      orientation: "horizontal",

      gestureOrientation: "horizontal",

      smoothWheel: true,

      syncTouch: false,
    };

    var lerp = parseNum(getAttr("lerp"), undefined);

    var duration = parseNum(getAttr("duration"), undefined);

    var easing = parseStr(getAttr("easing"), "");

    var easingFn = parseEasing(easing);

    if (lerp !== undefined) {
      options.lerp = lerp;
    } else if (duration !== undefined) {
      options.duration = duration;
    }

    if (easingFn) {
      options.easing = easingFn;
    }

    var orientation = parseStr(getAttr("orientation"), "");

    if (orientation) {
      options.orientation = orientation;
    }

    var gestureOrientation = parseStr(getAttr("gesture-orientation"), "");

    if (gestureOrientation) {
      options.gestureOrientation = gestureOrientation;
    }

    var smoothWheel = getAttr("smooth-wheel");

    if (smoothWheel !== null) {
      options.smoothWheel = parseBool(smoothWheel, true);
    }

    var wheelMultiplier = parseNum(getAttr("wheel-multiplier"), undefined);

    if (wheelMultiplier !== undefined) {
      options.wheelMultiplier = wheelMultiplier;
    }

    var touchMultiplier = parseNum(getAttr("touch-multiplier"), undefined);

    if (touchMultiplier !== undefined) {
      options.touchMultiplier = touchMultiplier;
    }

    var infinite = parseBool(getAttr("infinite"), false);

    if (infinite) {
      options.infinite = true;
    }

    var autoResize = parseBool(getAttr("auto-resize"), true);

    if (autoResize === false) {
      options.autoResize = false;
    }

    var jsonStr = getAttr("options-json");

    if (jsonStr) {
      try {
        var jsonOpts = JSON.parse(jsonStr);

        if (jsonOpts && typeof jsonOpts === "object") {
          for (var key in jsonOpts) {
            options[key] = jsonOpts[key];
          }
        }
      } catch (e) {}
    }

    return options;
  };

  Slider.prototype.setupLenisInstance = function () {
    if (!this.mq.matches) {
      return;
    }

    if (this.lenis) {
      return;
    }

    var options = this.getLenisOptions();

    try {
      this.lenis = new window.Lenis(options);

      LenisHub.add(this.lenis);

      this._lastLenisScrollWidth = -1;
      this._lastLenisClientWidth = -1;

      this.syncLenisDimensions(true);
      this.scheduleLayoutSettle(2200);
    } catch (e) {
      this.lenis = null;
    }
  };

  Slider.prototype.bindEvents = function () {
    this._onScroll = this.onScroll.bind(this);

    this.scroller.addEventListener("scroll", this._onScroll, {
      passive: true,
    });

    this._onResize = this.onResize.bind(this);

    window.addEventListener("resize", this._onResize);

    if (this.mq.matches) {
      this._onPD = this.onPointerDown.bind(this);

      this.scroller.addEventListener("pointerdown", this._onPD);

      this._onPM = this.onPointerMove.bind(this);

      this.scroller.addEventListener("pointermove", this._onPM);

      this._onPU = this.onPointerUp.bind(this);

      this.scroller.addEventListener("pointerup", this._onPU);

      this._onPC = this.onPointerCancel.bind(this);

      this.scroller.addEventListener("pointercancel", this._onPC);

      this._onPL = this.onPointerCancel.bind(this);

      this.scroller.addEventListener("pointerleave", this._onPL);

      this._onClickCap = this.onClickCapture.bind(this);

      this.scroller.addEventListener("click", this._onClickCap, true);
    }

    if (this.btnPrev) {
      this._onPrev = this.onPrevClick.bind(this);

      this.btnPrev.addEventListener("click", this._onPrev);
    }

    if (this.btnNext) {
      this._onNext = this.onNextClick.bind(this);

      this.btnNext.addEventListener("click", this._onNext);
    }

    if (this.mq.matches) {
      if (this.scrollBar) {
        this.scrollBar.style.touchAction = "none";

        this.scrollBar.style.cursor = "grab";
      }

      if (this.scrollTrack) {
        this.scrollTrack.style.userSelect = "none";

        this.scrollTrack.style.cursor = "pointer";

        this.scrollTrack.style.touchAction = "none";

        this._onTPD = this.onTrackPointerDown.bind(this);

        this.scrollTrack.addEventListener("pointerdown", this._onTPD);

        this._onTPM = this.onTrackPointerMove.bind(this);

        this.scrollTrack.addEventListener("pointermove", this._onTPM);

        this._onTPU = this.endBarDrag.bind(this);

        this.scrollTrack.addEventListener("pointerup", this._onTPU);

        this._onTPC = this.endBarDrag.bind(this);

        this.scrollTrack.addEventListener("pointercancel", this._onTPC);

        this._onTPL = this.endBarDrag.bind(this);

        this.scrollTrack.addEventListener("pointerleave", this._onTPL);
      }
    } else {
      if (this.scrollBar) {
        this.scrollBar.style.touchAction = "";

        this.scrollBar.style.cursor = "";
      }

      if (this.scrollTrack) {
        this.scrollTrack.style.userSelect = "";

        this.scrollTrack.style.cursor = "";

        this.scrollTrack.style.touchAction = "";
      }
    }

    var self = this;

    this._onWheelSync = function () {
      if (self._destroyed) {
        return;
      }

      self.syncLenisDimensions(false);
    };

    this.scroller.addEventListener("wheel", this._onWheelSync, {
      passive: true,
      capture: true,
    });

    this._onMQ = function () {
      if (self._destroyed) {
        return;
      }

      self.applyIOSScrollIndicatorMask();
      self.applyListStyles();
      self.setupCursorMode();
      self.rafUpdate();
      self.updateSlideState(true);

      self.scheduleLayoutSettle(1200);
    };

    if (this.mq.addEventListener) {
      this.mq.addEventListener("change", this._onMQ);
    } else if (this.mq.addListener) {
      this.mq.addListener(this._onMQ);
    }

    var imgs = Array.from(this.list.querySelectorAll("img"));

    imgs.forEach(function (img) {
      if (img.complete) {
        return;
      }

      var update = function () {
        if (self._destroyed) {
          return;
        }

        self.rafUpdate();
        self.setupCursorMode();
        self.applyIOSScrollIndicatorMask();
        self.applyListStyles();
        self.updateSlideState(true);

        self.scheduleLayoutSettle(1400);
      };

      img.addEventListener("load", update, {
        once: true,
      });

      img.addEventListener("error", update, {
        once: true,
      });

      self.imgHandlers.push({
        img: img,

        onL: update,

        onE: update,
      });
    });

    if (document.fonts && document.fonts.addEventListener) {
      this._onFontsDone = function () {
        if (self._destroyed) {
          return;
        }

        self.rafUpdate();
        self.setupCursorMode();

        self.scheduleLayoutSettle(1800);
      };

      document.fonts.addEventListener("loadingdone", this._onFontsDone);
    }

    if (this.ro) {
      this.ro.observe(this.list);

      this.ro.observe(this.scroller);

      if (this.scrollTrack) {
        this.ro.observe(this.scrollTrack);
      }

      this.syncMarginRefObservation();
    }

    this._onPH = function (event) {
      if (event && event.persisted) {
        return;
      }

      self.destroy();
    };

    window.addEventListener("pagehide", this._onPH);

    this._onPS = function (event) {
      if (!event || !event.persisted || self._destroyed) {
        return;
      }

      self.rafUpdate();
      self.setupCursorMode();
      self.applyIOSScrollIndicatorMask();
      self.applyListStyles();
      self.syncLenisDimensions(true);
      self.updateSlideState(true);
      self.scheduleLayoutSettle(2200);
    };

    window.addEventListener("pageshow", this._onPS);
  };

  Slider.prototype.init = function () {
    this._destroyed = false;

    this.captureBasePaddingBottomOnce();
    this.applyIOSScrollIndicatorMask();
    this.applyListStyles();

    var self = this;

    if (this.mq.matches) {
      loadLenis()
        .then(function () {
          if (self._destroyed) {
            return;
          }

          self.setupLenisInstance();
        })
        .catch(function () {});
    }

    this.rafUpdate();

    this.scheduleLayoutSettle(2200);

    this._onWL = function () {
      if (self._destroyed) {
        return;
      }

      self.rafUpdate();
      self.applyIOSScrollIndicatorMask();
      self.applyListStyles();
      self.syncLenisDimensions(true);
      self.updateSlideState(true);

      self.scheduleLayoutSettle(2200);
    };

    if (document.readyState === "complete") {
      requestAnimationFrame(function () {
        self._onWL();
      });
    } else {
      window.addEventListener("load", this._onWL, {
        once: true,
      });
    }

    if (
      document.fonts &&
      document.fonts.ready &&
      typeof document.fonts.ready.then === "function"
    ) {
      document.fonts.ready
        .then(function () {
          if (self._destroyed) {
            return;
          }

          self.rafUpdate();
          self.setupCursorMode();
          self.syncLenisDimensions(true);

          self.scheduleLayoutSettle(2200);
        })
        .catch(function () {});
    }

    this.setupCursorMode();
    this.bindEvents();
    this.updateSlideState(true);
  };

  Slider.prototype.destroy = function () {
    if (this._destroyed) {
      return;
    }

    this._destroyed = true;

    this.cancelLayoutSettle();

    this.stopInertia();

    if (this._touchClampTimer) {
      clearTimeout(this._touchClampTimer);

      this._touchClampTimer = 0;
    }

    if (this.lenis) {
      try {
        LenisHub.remove(this.lenis);
      } catch (e) {}

      try {
        this.lenis.destroy();
      } catch (e) {}

      this.lenis = null;
    }

    if (this._onScroll) {
      this.scroller.removeEventListener("scroll", this._onScroll);
    }

    if (this._onResize) {
      window.removeEventListener("resize", this._onResize);
    }

    if (this._onPD) {
      this.scroller.removeEventListener("pointerdown", this._onPD);
    }

    if (this._onPM) {
      this.scroller.removeEventListener("pointermove", this._onPM);
    }

    if (this._onPU) {
      this.scroller.removeEventListener("pointerup", this._onPU);
    }

    if (this._onPC) {
      this.scroller.removeEventListener("pointercancel", this._onPC);
    }

    if (this._onPL) {
      this.scroller.removeEventListener("pointerleave", this._onPL);
    }

    if (this._onClickCap) {
      this.scroller.removeEventListener("click", this._onClickCap, true);
    }

    if (this._onWheelSync) {
      this.scroller.removeEventListener("wheel", this._onWheelSync, true);
    }

    if (this._onPrev && this.btnPrev) {
      this.btnPrev.removeEventListener("click", this._onPrev);
    }

    if (this._onNext && this.btnNext) {
      this.btnNext.removeEventListener("click", this._onNext);
    }

    if (this.scrollTrack) {
      if (this._onTPD) {
        this.scrollTrack.removeEventListener("pointerdown", this._onTPD);
      }

      if (this._onTPM) {
        this.scrollTrack.removeEventListener("pointermove", this._onTPM);
      }

      if (this._onTPU) {
        this.scrollTrack.removeEventListener("pointerup", this._onTPU);
      }

      if (this._onTPC) {
        this.scrollTrack.removeEventListener("pointercancel", this._onTPC);
      }

      if (this._onTPL) {
        this.scrollTrack.removeEventListener("pointerleave", this._onTPL);
      }
    }

    if (this.mq.removeEventListener) {
      this.mq.removeEventListener("change", this._onMQ);
    } else if (this.mq.removeListener) {
      this.mq.removeListener(this._onMQ);
    }

    if (this._onWL) {
      window.removeEventListener("load", this._onWL);
    }

    if (this._onPH) {
      window.removeEventListener("pagehide", this._onPH);
    }

    if (this._onPS) {
      window.removeEventListener("pageshow", this._onPS);
    }

    if (
      this._onFontsDone &&
      document.fonts &&
      document.fonts.removeEventListener
    ) {
      document.fonts.removeEventListener("loadingdone", this._onFontsDone);
    }

    this.imgHandlers.forEach(function (h) {
      h.img.removeEventListener("load", h.onL);

      h.img.removeEventListener("error", h.onE);
    });

    this.imgHandlers = [];

    this.clearCursorBindings();

    this.scroller.style.cursor = "";

    this.scroller.style.removeProperty("--rt-slider-mask-bg");

    this.scroller.style.removeProperty("--rt-slider-mask-h");

    this.scroller.style.removeProperty("--rt-slider-base-pb");

    if (this.ro) {
      this.ro.disconnect();
    }

    this._marginRefObserved = null;

    this._lastLenisScrollWidth = -1;
    this._lastLenisClientWidth = -1;

    if (this._injectedKey) {
      removeInjected(this._injectedKey);

      this._injectedKey = null;
    }
  };

  var state = {
    instances: {},
    order: [],
  };

  function init() {
    var roots = document.querySelectorAll("[data-rt-slider]");

    var autoCount = 0;

    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];

      var id = root.getAttribute("data-rt-slider-id");

      if (!id) {
        autoCount++;

        id = "slider-" + autoCount;

        root.setAttribute("data-rt-slider-id", id);
      }

      if (state.instances[id]) {
        continue;
      }

      var inst = new Slider(root, id);

      if (inst.valid) {
        state.instances[id] = inst;

        state.order.push(id);

        inst.init();
      }
    }
  }

  function makeApi() {
    return {
      __initialized: true,

      ids: function () {
        return state.order.slice();
      },

      get: function (id) {
        return state.instances[id] || null;
      },

      getSlideState: function (id) {
        var inst = state.instances[id];

        return inst ? inst.getSlideState() : null;
      },

      getScrollState: function (id) {
        var inst = state.instances[id];

        return inst ? inst.getScrollState() : null;
      },

      getProgress: function (id) {
        var inst = state.instances[id];

        return inst ? inst.getProgress() : 0;
      },

      refresh: function () {
        var keys = state.order;

        for (var i = 0; i < keys.length; i++) {
          var inst = state.instances[keys[i]];

          if (inst) {
            inst.onResize();
          }
        }
      },

      destroy: function (id) {
        if (typeof id === "string") {
          var inst = state.instances[id];

          if (inst) {
            inst.destroy();

            delete state.instances[id];

            var idx = state.order.indexOf(id);

            if (idx > -1) {
              state.order.splice(idx, 1);
            }
          }

          return;
        }

        for (var i = 0; i < state.order.length; i++) {
          var k = state.order[i];

          if (state.instances[k]) {
            state.instances[k].destroy();
          }
        }

        state.instances = {};

        state.order = [];
      },
    };
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  window[RT_NS] = makeApi();
})();
